<template>
  <div style="width:100vw">
    <van-loading size="40" style="padding-top:30%"  v-show="isShowLoading" vertical><span style="font-size:26px"></span></van-loading>
    <div class="error" v-if="errorMsg">{{errorMsg}}</div>
    <iframe ref="iframe" :src='iframeSrc' id='iframe' v-if="iframeSrc" class="iframe"></iframe>
  </div>
</template>


<script>

import {getRedirectParam, weChatPublicAuthLogin,singlePageClick, getCallBackDomain, checkSession} from '@/api/qrcode'
import { getWechatPublicAuthorizationUrl } from '@/api/login'
import {getCookie, clearAllCookie } from '@/utils/tool'
import { Loading } from 'vant';
import qs from "qs";
export default {
  data() {
    return{
      iframeSrc: '',
      isShowLoading: true,
      errorMsg: '',
    }
  },

  created() {
    document.title = '\u200b'
  },
  computed: {
    domainInfo() {
      return this.$store.state.domainInfo
    }
  },
  components: {
    'van-loading': Loading,
  },
  mounted() {
    const session = getCookie('SESSION')
    if(session) {
      this.checkSession()
    } else {
      this.getCallBackDomain()
    }
  },

  methods: {
    async getCallBackDomain() {
      const { protocol, origin,  pathname, hostname, href} = window.location
      try {
        const res = await getCallBackDomain()
        // const res = {
        //   mdata: {
        //      callBackDomain: 'testcallback.qianshoushou.com',
        //      redirectType: 1,
        //   }
        // }
        const {callBackDomain} = res.mdata
        /** 如果 */

        /** 判断是否有cookie */
        clearAllCookie()
        this.isShowLoading = false
        this.iframeSrc = `${protocol}//${callBackDomain}/one.html`
      } catch (error) {
         this.isShowLoading = false
      }
    },
    async checkSession() {
      const res = await checkSession()
      // return
      if(res.mdata.validFlag) {
        this.getRedirectParam()
      } else {
        this.getCallBackDomain()
      }
    },
    async getRedirectParam(){
      this.isShowLoading = false
      /** 判断是否有cookie */
      const session = getCookie('SESSION')
      const { protocol, origin,  pathname, hostname, href} = window.location
      try {
        const params = {
          content: href
        }
        const res = await getRedirectParam(params)
        this.isShowLoading = false
        // const res = {
        //   mdata: {
        //     callBackDomain: 'testcallback.qianshoushou.com',
        //     landingDomain: 'qiaomu.lititi.com',
        //     errorMsg: 'adada'
        //   }
        // }
        // 错误判断
        this.errorMsg = res.mdata.errorMsg
        if(this.errorMsg) {
          return
        }

        const { query } = this.$route
         const newQuery = `entry=${query.entry || ''}&inviteCode=${query.inviteCode || ''}&oauthId=${query.oauthId || ''}&token=${query.token || ''}`
        // 不是落地域名了 即A域名 已经获取到cookie 需求到b2域名设置cookie
        const url = `${protocol}//${res.mdata.landingDomain}/ql/${this.$route.params.id}`
        this.$store.commit('setDomain', res)
        /** 判断是否需要生产cookie */
        if(res.mdata.redirectType == 1) {
          /** 跳转b域名 */
           window.location.href = `${protocol}//${res.mdata.callBackDomain}/two.html?redirectUrl=${url}&session=${session}&${newQuery}`
           return
        }

        window.location.href = `${url}?session=${session}&${newQuery}`

        /** 判断是否需要跳转b域名 */
        /*if(res.mdata.landingDomain == hostname) {
          if(query.token) {
            localStorage.setItem('token', query.token)
          }
          // 同一个域名
          this.$router.push({
            name: 'land',
            params: this.$route.params,
            query: {
              session: getCookie('SESSION'),
              ...qs.parse(newQuery)
            }
          })
        } else {
          // 跳转落地域名
          window.location.href = `${url}?session=${session}&${newQuery}`
        }*/

      } catch (error) {
        this.isShowLoading = false
        console.log(error)
      }
    },
  },
}
</script>

<style scoped lang='less'>
.qrcode-main{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 260px;
  width: 100vw;
  .item-qrcode{
    width:80vw;
    padding-bottom: 100px;
    margin-top: -100px;
    color: #333;
    .item-copy{
      display: flex;
      justify-content: space-between;
      .copy-qrcode{
        width: 40px;
        height: 40px;
        margin-top: 5px;
      }
    }
    .qrcode-url{
      margin-top: 10px;
      word-break: break-all;
    }
  }
  .image{
    width: 360px;
    height: 360px;
  }
  .text-content{
    margin-top: 50px;
    text-align: center;
    font-size: 38px;
    word-break:break-all;
    white-space: pre-wrap;
    // -webkit-touch-callout:none; /*系统默认菜单被禁用*/
    // -webkit-user-select:none; /*webkit浏览器*/
    // -khtml-user-select:none; /*早期浏览器*/
    // -moz-user-select:none;/*火狐*/
    // -ms-user-select:none; /*IE10*/
    // user-select:none;
  }
  .qrcode-text{
    margin-top: -100px;
    margin-bottom: 100px;
  }
  .qrcode-item{
    position: relative;
    .download{
      position: absolute;
      width: 60px;
      height: 60px;
      right: -100px;
      margin-top: -60px;
    }
  }
}
// 小程序
.wecaht {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  &-img {
    width: 200px;
    height: 200px;
    border-radius: 20px;
  }
  .test-btn{
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    height: 80px;
    width: 90%;
    background: #007aff;
    border-radius: 40px;
    color: #fff;
    font-size: 32px;
    font-weight: 700;
    border: none;
    margin-top: 100px;
  }
}
img {
  pointer-events: none;

}
.qrcode {
  pointer-events: all;
  display: none;
}

.qrcode-image{
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  width: 100vw;
  height: 80vh;
}
#launch-btn {
  position: absolute;

  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
}
.wechat-btn2 {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background: #007aff;
  border-radius: 20px;
  color: #fff;
  font-weight: 700;
  border: none;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99;
}
.web-link{
  width: 100vw;
  .web-link-textarea{
    width: 666px;
    height: 300px;
    padding: 20px;
    margin:30px 20px;
    background-color: #fff;
    border-radius: 20px;
    border: 1px solid #ddd;
  }
  .visit{
    margin: 100px;
    padding: 20px;
    border-radius: 50px;
    background-color: #FD1576;
    color: #fff;
    text-align: center;
  }
}

.open-app{
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  .view-app{
    width: 300px;
    height: 300px;
    margin: 60px 0;
    .app-icon{
      width: 300px;
      height: 300px;
      object-fit: contain;
    }
  }
  .open-app-btn-11{
    width: 100%;
    text-align: center;
    // display: flex;
    // align-items: center;
    // background: red;
    .button-text{
      margin: 0 16px;
      display: inline-block;
      word-break: break-all;
      padding: 12px 36px;
      color: #fff;
      border-radius: 36px;
      background-color: #3477f5;

      font-size: 38px;
    }
  }

  .text-content{
    margin: 20px;
    word-break:break-all;
    white-space: pre-wrap;
    font-size: 26px;
  }
  .view-img{
    .text-img{
      margin: 20px;
      width: 710px;
      object-fit: contain;
    }
  }
}
.iframe {
  position: fixed;
  top: -100000px;
}
.show-img-content{
  position: fixed;
  left: 0;
  right: 0;
  top: 82vh;
  text-align: center;
  word-break:break-all;
  margin: 0 20px;
  white-space: pre-wrap;

  overflow:hidden;
  text-overflow:ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  -webkit-line-clamp:5;
}
.error {
  text-align: center;
  font-size: 40px;
  padding-top: 100px;
  color: #222;
}
</style>
